import React,{forwardRef} from 'react'
import { CheckOutlined, CopyOutlined} from '@ant-design/icons';
import { Alert, Button,Typography } from 'antd';
import BaseModal from 'components/BaseModal';

export default forwardRef(function WebhookTokenPopup({webhookTokenUrl, afterClose}, ref) {

    const tokenGenerateSection = (
        <>
        <div className="text-bold">URL</div>
        <Typography.Text copyable={{ 
            text: webhookTokenUrl,
            icon: [<Button key="copy-icon" icon={<CopyOutlined />} type="link">Copy</Button>, <Button key="copied-icon" icon={<CheckOutlined />} type="link">Copied</Button>], 
        }}>{webhookTokenUrl}</Typography.Text>
        </>
    )


    return(
        <BaseModal modalProps={{title: "Webhook", footer: null}} ref={ref} afterClose={afterClose}>
            {webhookTokenUrl && <Alert className="m-t-l" description={tokenGenerateSection} type="info"/>}
        </BaseModal>
    )
})
